module.exports = __webpack_public_path__ + "img/pending.bf73fcf8.gif";